(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var wrap = document.querySelector('[data-ckc]');
  if (!wrap) return;
  var panel = wrap.querySelector('[data-ckc-panel]');
  var SID = 'ck-cart-drawer', busy = false, lastFocus = null, timer = 0;
  var store = function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } };
  var setCounts = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
  };
  var extras = function () {
    var on = store('om-wel') === '1', dlg = document.getElementById('om-welcome');
    var w = wrap.querySelector('[data-ckc-wel]'); if (w) w.hidden = !on;
    var c = wrap.querySelector('[data-ckc-welcome]'); if (c) c.hidden = on || !dlg;
  };
  var swap = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ckc-inner]'), cur = wrap.querySelector('[data-ckc-inner]');
    if (!fresh || !cur) return;
    cur.replaceWith(fresh);
    setCounts(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    extras();
  };
  var open = function () {
    window.clearTimeout(timer);
    if (wrap.hidden) lastFocus = document.activeElement;
    wrap.hidden = false;
    document.documentElement.classList.add('ckc-lock');
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { wrap.classList.add('is-open'); }); });
    extras();
    var x = wrap.querySelector('.ckc-x'); if (x) x.focus({ preventScroll: true });
  };
  var close = function () {
    wrap.classList.remove('is-open');
    document.documentElement.classList.remove('ckc-lock');
    timer = window.setTimeout(function () { wrap.hidden = true; }, 340);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  var refresh = function (openAfter) {
    return fetch(root + '?sections=' + SID, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (j) { if (j && j[SID]) swap(j[SID]); if (openAfter) open(); })
      .catch(function () { if (openAfter) window.location.href = root + 'cart'; });
  };
  var post = function (url, body) {
    if (busy) return;
    busy = true; wrap.classList.add('is-busy');
    body.sections = SID; body.sections_url = window.location.pathname;
    fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (j.sections && j.sections[SID]) swap(j.sections[SID]); else return refresh(false); })
      .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'); })
      .then(function () { busy = false; wrap.classList.remove('is-busy'); });
  };
  var trap = function (e) {
    var f = panel.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]):not([hidden]),input,select,textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  wrap.addEventListener('click', function (e) {
    if (e.target.closest('[data-ckc-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-ckc-q]');
    if (q) { post('cart/change.js', { id: q.getAttribute('data-key'), quantity: Math.max(0, parseInt(q.getAttribute('data-ckc-q'), 10) || 0) }); return; }
    var a = e.target.closest('[data-ckc-add]');
    if (a) { post('cart/add.js', { items: [{ id: parseInt(a.getAttribute('data-ckc-add'), 10), quantity: 1 }] }); return; }
    if (e.target.closest('[data-ckc-welcome]')) {
      var d = document.getElementById('om-welcome');
      close();
      if (d && typeof d.showModal === 'function') window.setTimeout(function () { d.showModal(); }, 350);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (wrap.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') trap(e);
  });
  document.addEventListener('click', function (e) {
    var l = e.target.closest('a[href]');
    if (!l || wrap.contains(l) || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = l.getAttribute('href') || '';
    if (!/^(https?:\/\/[^/]+)?\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(href)) return;
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    e.preventDefault();
    open();
    refresh(false);
  });
  ['[data-om-sheet]', '[data-sheet]'].forEach(function (sel) {
    var s = document.querySelector(sel);
    if (!s || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (s.hidden) return;
      s.hidden = true;
      refresh(true);
    }).observe(s, { attributes: true, attributeFilter: ['hidden'] });
  });
  window.CKCart = { open: open, close: close, refresh: refresh };
})();
